import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Tags } from "lucide-react";
import CategoriesTab from "@/features/ventes/components/categories/CategoriesTab";

export const Route = createFileRoute("/_app/ventes/categories/")({
  loader: requirePermission(PERMISSIONS.VENTES.CATEGORIES.VIEW),
  staticData: {
    title: "Catégories",
    icon: Tags,
    tab_icon: Tags,
    permission: PERMISSIONS.VENTES.CATEGORIES.VIEW,
    module: "ventes",
    order: 20,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
    description: "Gestion des catégories",
  },
  component: CategoriesTab,
});
